<div class="confirm-body">
  <div class="confirm-icon" [class.confirm-icon--danger]="data.danger">
    <mat-icon>{{ icon }}</mat-icon>
  </div>

  <div class="confirm-text">
    <h2 mat-dialog-title class="confirm-title">{{ data.title }}</h2>
    <mat-dialog-content class="confirm-content">
      <p class="message">{{ data.message }}</p>
    </mat-dialog-content>
  </div>
</div>

<mat-dialog-actions class="confirm-actions" align="end">
  <button mat-stroked-button class="btn-cancel" (click)="cancel()" [autofocus]="data.danger">
    {{ data.cancelLabel ?? 'Cancel' }}
  </button>
  <button
    mat-flat-button
    class="btn-confirm"
    [class.btn-confirm--danger]="data.danger"
    (click)="confirm()"
    [autofocus]="!data.danger"
  >
    {{ data.confirmLabel ?? 'Confirm' }}
  </button>
</mat-dialog-actions>